import {
  DiscountType,
  PackagedBeerDetailsContainer,
  RecallType,
} from "../../gql/hooks";
import {
  ProductConditionFormType,
  ProductConditionType,
} from "../../redux/slices/proposal_old/types/productConditionTypes";

// Classic proposal commercial conditions
export function constructProductsConditionByContainer(
  bottlesIds: number[],
  kegsIds: number[],
  commercialValues: ProductConditionType[],
  isPending?: boolean,
  params: { kegs: string[]; bottles: string[] } = { kegs: [], bottles: [] },
) {
  let tmpCommercialValues = [...commercialValues];

  const kegProductConditionForms: ProductConditionFormType[] = kegsIds.map(
    (productId) => {
      const commercialValueIndex = tmpCommercialValues.findIndex(
        (_) =>
          _.productId === productId &&
          _.container === PackagedBeerDetailsContainer.Keg,
      );
      const commercialValue = tmpCommercialValues[commercialValueIndex];

      if (!!commercialValue) {
        tmpCommercialValues[commercialValueIndex] = null as any;
        tmpCommercialValues = tmpCommercialValues.filter((_) => !!_);
      }

      const packagedProductIdSelected = params.kegs.find(
        (_) => _.split("_")[0] === productId.toString(),
      );

      const packagedProductId = packagedProductIdSelected?.split("_")[1]
        ? Number(packagedProductIdSelected.split("_")[1])
        : commercialValue?.packagedProductId;

      return {
        isPending,
        productId,
        formId: `${PackagedBeerDetailsContainer.Keg}-${productId}-${
          Date.now() + Math.random() * 1000
        }${commercialValue?.packagedProductId || ""}`,
        commercialConditions: {
          container: PackagedBeerDetailsContainer.Keg,
          discountType:
            commercialValue?.discountType || DiscountType.Percentage,
          discountValue: commercialValue?.discountValue
            ? String(commercialValue.discountValue)
            : undefined,
          discountX: commercialValue?.discountX
            ? String(commercialValue.discountX)
            : undefined,
          discountY: commercialValue?.discountY
            ? String(commercialValue.discountY)
            : undefined,
          recallType: commercialValue?.recallType || RecallType.LiterRecall,
          recallValue: commercialValue?.recallValue
            ? String(commercialValue.recallValue)
            : undefined,
          recallX: commercialValue?.recallX || undefined,
          recallY: commercialValue?.recallY || undefined,
          amortizationType:
            commercialValue?.amortizationType || RecallType.EuroPerLiterLoan,
          amortizationValue: commercialValue?.amortizationValue
            ? String(commercialValue.amortizationValue)
            : undefined,
          amortizationX: commercialValue?.amortizationX || undefined,
          amortizationY: commercialValue?.amortizationY || undefined,
          packagedProductId:
            packagedProductId || commercialValue?.packagedProductId,
          packagedProductUnitNb: String(
            commercialValue?.packagedProductUnitNb || "",
          ),
          customPrice:
            commercialValue?.customPrice ||
            (commercialValue as any)?.packagedProductPrice ||
            undefined,
          freePackagedProductUnitsNb: String(
            commercialValue?.freePackagedProductUnitsNb || "",
          ),
        },
      };
    },
  );

  const bottleProductConditionForms: ProductConditionFormType[] =
    bottlesIds.map((productId) => {
      const commercialValueIndex = tmpCommercialValues.findIndex(
        (_) =>
          _.productId === productId &&
          _.container === PackagedBeerDetailsContainer.Bottle,
      );
      const commercialValue = tmpCommercialValues[commercialValueIndex];

      if (!!commercialValue) {
        tmpCommercialValues[commercialValueIndex] = null as any;
        tmpCommercialValues = tmpCommercialValues.filter((_) => !!_);
      }

      const packagedProductIdSelected = params.bottles.find(
        (_) => _.split("_")[0] === productId.toString(),
      );

      const packagedProductId = packagedProductIdSelected?.split("_")[1]
        ? Number(packagedProductIdSelected.split("_")[1])
        : commercialValue?.packagedProductId;

      return {
        isPending,
        productId,
        formId: `${PackagedBeerDetailsContainer.Bottle}-${productId}-${
          Date.now() + Math.random() * 1000
        }${commercialValue?.packagedProductId || ""}`,
        commercialConditions: {
          container: PackagedBeerDetailsContainer.Bottle,
          discountType:
            commercialValue?.discountType || DiscountType.Percentage,
          discountValue: commercialValue?.discountValue
            ? String(commercialValue.discountValue)
            : undefined,
          discountX: commercialValue?.discountX
            ? String(commercialValue.discountX)
            : undefined,
          discountY: commercialValue?.discountY
            ? String(commercialValue.discountY)
            : undefined,
          recallType: commercialValue?.recallType || RecallType.LiterRecall,
          recallValue: commercialValue?.recallValue
            ? String(commercialValue.recallValue)
            : undefined,
          recallX: commercialValue?.recallX || undefined,
          recallY: commercialValue?.recallY || undefined,
          amortizationType:
            commercialValue?.amortizationType || RecallType.EuroPerLiterLoan,
          amortizationValue: commercialValue?.amortizationValue
            ? String(commercialValue.amortizationValue)
            : undefined,
          amortizationX: commercialValue?.amortizationX || undefined,
          amortizationY: commercialValue?.amortizationY || undefined,
          packagedProductId:
            packagedProductId || commercialValue?.packagedProductId,
          packagedProductUnitNb: String(
            commercialValue?.packagedProductUnitNb || "",
          ),
          customPrice:
            commercialValue?.customPrice ||
            (commercialValue as any)?.packagedProductPrice ||
            undefined,
          freePackagedProductUnitsNb: String(
            commercialValue?.freePackagedProductUnitsNb || "",
          ),
        },
      };
    });

  return [...kegProductConditionForms, ...bottleProductConditionForms];
}

// Short proposal commercial conditions
export function constructProductsCommercialCondition(
  productIds?: number[],
  commercialValues?: ProductConditionType[],
) {
  if (!productIds) return [];
  return productIds.map((productId) => {
    const match = commercialValues?.find((_) => _.productId === productId);

    return {
      productId: productId,
      formId: `${match?.formId || productId}`,
      commercialConditions: {
        container: match?.container || PackagedBeerDetailsContainer.Bottle,
        discountValue: match?.discountValue || undefined,
        discountType: match?.discountType || DiscountType.Percentage,
        discountX: match?.discountX || undefined,
        discountY: match?.discountY || undefined,
        recallType: match?.recallType || RecallType.LiterRecall,
        recallValue: match?.recallValue || undefined,
        recallX: match?.recallX || undefined,
        recallY: match?.recallY || undefined,
        amortizationType:
          match?.amortizationType || RecallType.EuroPerLiterLoan,
        amortizationX: match?.amortizationX || undefined,
        amortizationY: match?.amortizationY || undefined,
        packagedProductId: match?.packagedProductId,
        packagedProductUnitNb: match?.packagedProductUnitNb || "",
        freePackagedProductUnitsNb: match?.freePackagedProductUnitsNb || "",
        customPrice: match?.customPrice || undefined,
        amortizationValue: match?.amortizationValue || undefined,
      },
    };
  });
}
